<template>
    <div style="height: 20vh;">
        <a-row style="padding: 40px;color: #fff;text-align: center" type="flex" justify="center">
            <a-col :span="10" style=";">
                <p class="ab-tit">关于我们</p>
                <p class="ab-desc">ABOUT US</p>
                <a-row type="flex" justify="start">
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div><a-icon type="shop" class="ab-icon" />
                            </div>
                            <div>
                                <div class="enter-16">优秀商家覆盖</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div><a-icon type="clock-circle" class="ab-icon" />
                            </div>
                            <div>
                                <div class="enter-16">专业审核信息有保障</div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="start">
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div><a-icon type="api" class="ab-icon" />
                            </div>
                            <div>
                                <div class="enter-16">一键匹配供需信息</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div><a-icon type="safety" class="ab-icon" />
                            </div>
                            <div>
                                <div class="enter-16">平均48小时找到满意商家</div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="8">
                <p class="ab-tit">与我联系</p>
                <p class="ab-desc">CONTACT US</p>
                <a-row type="flex" justify="start">
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div><a-icon type="mail" theme="filled" class="ab-icon" />
                            </div>
                            <div>
                                <div class="enter-16">64391343@qq.com</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div><a-icon type="phone" theme="filled" class="ab-icon" />
                            </div>
                            <div>
                                <div class="enter-16">0931-8700690</div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="start">
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div>
                                <a-icon type="user" class="ab-icon" />
                            </div>
                            <div>
                                <div class="enter-16">在线客服</div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="10">
                        <div class="enter-flex">
                            <div>
                                <div class="enter-16">
                                    <a-icon type="wechat" class="ab-icon" />
                                    <a-icon type="weibo-square" class="ab-icon" />
                                    <a-icon type="qq" class="ab-icon" />
                                </div>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="6">
                <p class="ab-tit">友情链接</p>
                <p class="ab-desc">FRIENDSHIP LINK</p>
                <p>
                    <a class="enter-16">兰州宜元中林</a>
                    <a href="https://www/baidu.com" class="enter-16">百度</a>
                    <a class="enter-16">永登商业厅</a>
                </p>

            </a-col>
        </a-row>
        <a-divider :dashed="true" style="border-color: gray;"/>
        <p class="enter-16" style="color: gray;font-size: 12px;padding: 0px 40px;padding-bottom: 30px;">陇ICP备202300000X号Copyright©2024永登县政府版权所有甘公网安备6201020200000X号</p>
    </div>
</template>
<script>
import { mixin, mixinDevice } from '@/utils/mixin.js'

export default {
    name: "AboutUs",
    components: {},
    mixins: [mixin, mixinDevice],
    data() {
        return {
        }
    }
}
</script>
<style scoped>
.ab-tit {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0px;
}

.ab-desc {
    text-align: left;
    font-size: 18px;
    color: gray;
    margin-bottom: 0px;
}

.enter-flex {
    float: left;
    margin-top: 10px;
    display: flex;
    font-weight: 500;
    color: #fff;
}

.enter-16 {
    color: #fff;
    float: left;
    font-size: 16px;
    margin-left: 5px;
}

.enter-24 {
    font-size: 12px;
}

.ab-icon {
    font-size: 20px;
    margin-left: 5px;
}
</style>